import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const pillars = ['Ventas', 'Agenda', 'Precios', 'Instagram', 'Finanzas', 'Escala'];
const tomos = [{
  n: 1,
  title: 'Fundamentos de la Agenda Blindada',
  desc: 'Sistema base para organizar, proteger y proyectar tu agenda sin depender de la suerte.'
}, {
  n: 2,
  title: 'Psicología de la clienta que paga caro',
  desc: 'Cómo atraer y retener clientas premium que valoran tu trabajo y no regatean el precio.'
}, {
  n: 3,
  title: 'Scripts de Venta por WhatsApp',
  desc: 'Mensajes exactos para transformar cada consulta en turno confirmado. Sin perseguir a nadie.'
}, {
  n: 4,
  title: 'Protocolo Anti-Cancelaciones',
  desc: 'Sistema concreto para eliminar huecos de último momento y blindar tus ingresos diarios.'
}, {
  n: 5,
  title: 'Ingeniería de Precios en Inflación',
  desc: 'Cómo fijar y actualizar precios en Argentina sin perder clientas ni trabajar para los insumos.'
}, {
  n: 6,
  title: 'Instagram Magnético para pestañas',
  desc: 'Transformá tu perfil en una máquina de consultas sin depender del algoritmo de turno.'
}, {
  n: 7,
  title: 'Fidelización extrema: La Clienta que Vuelve Sola',
  desc: 'Protocolos para convertir una clienta ocasional en embajadora que llena tu agenda.'
}, {
  n: 8,
  title: 'Gestión del Tiempo',
  desc: 'Cómo trabajar 6 días a la semana sin agotarte, con tiempos reales y energía para vivir.'
}, {
  n: 9,
  title: 'Finanzas para Lashistas',
  desc: 'Separar caja y bolsillo. Calcular ganancia neta real. Saber cuánto ganás por hora.'
}, {
  n: 10,
  title: 'Publicidad Low-Cost en Meta',
  desc: 'Atraer clientas nuevas con el valor de un café por día, sin conocimientos técnicos previos.'
}, {
  n: 11,
  title: 'Escalabilidad y Primer Equipo',
  desc: 'El mapa para dejar de cambiar tiempo por dinero y construir un estudio de verdad.'
}, {
  n: 12,
  title: 'Mentalidad de Dueña',
  desc: 'Cómo pensar, decidir y actuar como dueña de negocio. El capítulo que ningún curso te da.'
}];
const includes = ['Scripts listos para copiar', 'Protocolos paso a paso', 'Plantillas editables', 'Ejemplos del mercado ARG', 'Checklists de implementación', 'Estrategias anti-inflación', 'Casos reales de lashistas', 'Listo para aplicar desde hoy'];
export function Tomos() {
  return <section aria-label="Los 12 tomos" className="bg-ink" data-id="element-156" data-mp="24xt6d11dnlci">
      <div className="mx-auto max-w-6xl px-5 py-20 pb-[28px] pt-[4px]" data-id="element-157" data-mp="2iym37sf5isis">
        <div className="text-center pt-[5px]" data-id="element-158" data-mp="2iwswye8gaabb">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-rose-soft" data-id="element-159" data-mp="2exk3lahboega">🏆 MegaPack™ Agenda Llena</p>
          <h2 className="mt-3 font-display text-3xl font-black text-white sm:text-4xl" data-id="element-160" data-mp="2sndqhn99oond">
            12 Tomos + 5 Bonos
          </h2>
          <p className="mt-2 text-base text-white/60" data-id="element-161" data-mp="2nq430d5fun26">100+ páginas — Todo resuelto.</p>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-162" data-mp="32n4kzoxtv3ng">
            {pillars.map(p => <span key={p} className="rounded-full border border-gold/30 bg-gold/10 px-3 py-1 text-xs font-bold uppercase tracking-wide text-gold" data-id="element-163" data-mp="2xotbjfbg2v5r">
                {p}
              </span>)}
          </div>
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-164" data-mp="3la407v5obllw">
          {tomos.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.06
        }} className="group rounded-2xl border border-white/10 bg-ink-2 p-5 transition-colors duration-200 hover:border-rose/40 pt-[7px]" data-id="element-165" data-mp="37ama9cgn62ay" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-166" data-mp="2om7gihexwa6g">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-rose/15 font-display text-lg font-black text-rose" data-id="element-167" data-mp="2tj7nqvniziz5">
                  {t.n}
                </span>
                <h3 className="text-sm font-bold leading-tight text-white" data-id="element-168" data-mp="2jl9xy3q0pe4f">{t.title}</h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-white/60" data-id="element-169" data-mp="3mwz0j1iearkn">{t.desc}</p>
            </motion.article>)}
        </div>

        
      </div>
    </section>;
}